const ru={
    login:{
        title:'Система отправки данных',
        email:'Электронная почта',
        password:'Пароль',
        forgotPassword:"Забыли пароль?",
        logout:"выход",
        inEmail:'Неверный формат электронной почты',
        loginfailed:'Вход не выполнен, неверный адрес электронной почты или пароль',
        enterEmail:'Пожалуйста, введите вашу электронную почту',
        enterPassword:'Пожалуйста, введите ваш пароль',
        enterCode:'Пожалуйста, введите код подтверждения',
        passwordNotMatch:'Пароли не совпадают',
    },
    forgot:{
        forgotPassword:"Забыли пароль",
        tip:"Мы вышлем код на ваш адрес электронной почты",
        email:'Электронная почта',
        code:"Код подтверждения",
        password:'Пароль',
        confirmPassword:"Подтвердите пароль",
        send:"Отправить",
        submit:"Отправить",
        login:"Войти"
    }
    ,
    menu:{
        mange:"Управление формами",
        mangeTip:"数据提报表单的创建、数据查看",

        submission:"Отправка форм",
        account:"Управление аккаунтом",
        uwell:"Uwell Account",
        external:"Внешняя учетная запись"
    },
    editList:{
        fill:"Заполнить",
        record:"Запись",
        createdTime:"Время создания",
        formTitle:"Название формы",
        titleTip:"Введите заголовок формы",
        showInput:"Показать вам формы, которые нужно заполнить, и заполненные записи"
    },
    editFill:{
        save:'сохранить',
        nosave:'Не сохранять',
        backSaveTip:'Хотите сохранить введенный контент?',
        submitted:'отправлено',
        notsubmitted:'не отправлено',

        submit:"Отправить",
        submitSuccess:"Отправлено успешно",
        fillAgain:"Заполнить еще раз",

        invalid:"Неверные параметры",
        noTime:"Форма больше не действительна и её нельзя заполнить.",
        failedStop:"Ошибка отправки. Сбор формы прекращен.",
        failedNot:"Ошибка отправки. Форма не существует.",
        failedPassed:"Не удалось отправить, форму можно заполнить только один раз.",
        failedOnce:"Отправка не выполнена, форму можно заполнять только один раз в день.",
        noempty:"Обязательные поля не могут быть пустыми."
    },
    editInfo:{
        SubmitTime:"Время отправки",
        submitter:'Отправитель',
        search:"Поиск",
        clear:"Очистить",
        filter:"Фильтр",
        fieldSetting:"Настройки поля",
        export:"Экспортировать",
        createBy:"Создатель",
        updateTime:"Время обновления",
        status:'состояние',
        action:"Действие",
        detail:"Детали",
        edit:"Редактировать",
        more:"Более",
        copy:"копировать",
        startDate:"Дата начала",
        endDate:"Дата окончания",
        selectAll:"Выбрать все",
        confirm:"Подтвердить",
        cancel:"Отменить",
        addFilter:"Добавить условие фильтра",
        pleaseSelect:"Пожалуйста, выберите",
        pleaseFillIn:"Пожалуйста, заполните",
        delete:"Удалить",
        filterIncom:`Условие фильтра в строке {num} неполное, пожалуйста, подтвердите.`,
        noData:"Нет данных",
        uploadfailed:'Загрузка не удалась',
        total:`Итого {num}`,

        deleteTip: 'Это действие удалит данные. Продолжить?',
        deleteSuccess: 'Успешно удалено'
    },
    fillIn:{
        equal:'Равно',
        noequal:'Не равно',
        contains:'Содержит',
        notcontains:'Не содержит',
        empty:'Пустое',
        notempty:'Не пустое',
        before:'Раньше',
        after:'Позже',
        greaterequal:'Больше или равно',
        lessequal:'Меньше или равно',
        greaterthan:'Больше',
        lessthan:'Меньше',

    },
    editEye:{
        detail:"Подробности формы"
    },
    editUpdate:{
        editForm:"Изменить форму",
        returnList:"Вернуться к списку"
    }
}

export default ru;